import React, { useEffect, lazy, Suspense } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import {
  LOGIN_URL, SIGNUP_URL, ROOT_URL, RESET_PASSWORD_UI_URL,
} from './routes';
import axiosInitializer from './axiosInitializer';
import storageHelpers from './utils/storageHelpers';
import {
  setCurrentUser,
  setMealTypes,
} from './actionCreators/loginActionCreators';
import { CenteredLoader } from './components/shared/Loader';

const LayoutContainer = lazy(() => import('./containers/LayoutContainer'));
const SignUpContainer = lazy(() => import('./containers/SignUpContainer'));
const LoginContainer = lazy(() => import('./containers/LoginContainer'));
const ResetPasswordContainer = lazy(() => import('./containers/ResetPasswordContainer'));


axiosInitializer.load();

function App() {
  const localStorageCurrentUser = storageHelpers.getItem('currentUser');
  const localStorageMealTypes = storageHelpers.getItem('mealTypes');
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.loginReducer.isLoading);

  // check if user session exists
  useEffect(() => {
    // set current user from localstorage to loginReducer
    dispatch(setCurrentUser(localStorageCurrentUser));
    if (localStorageMealTypes) {
      dispatch(setMealTypes(localStorageMealTypes));
    }
    return () => {
      setCurrentUser(null);
      setMealTypes(null);
    };
  }, [dispatch, localStorageCurrentUser, localStorageMealTypes]);

  if (isLoading) {
    return <CenteredLoader />;
  }

  return (
    <BrowserRouter>
      <Suspense fallback={<CenteredLoader />}>
        <Switch>
          <Route path={RESET_PASSWORD_UI_URL} component={ResetPasswordContainer} />
          <Route path={LOGIN_URL} component={LoginContainer} />
          <Route path={SIGNUP_URL} component={SignUpContainer} />
          <Route path={ROOT_URL} component={LayoutContainer} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
}

export default React.memo(App);
